import { render, staticRenderFns } from "./OrderPanelVals.vue?vue&type=template&id=20468e5c&scoped=true"
import script from "./OrderPanelVals.vue?vue&type=script&lang=js"
export * from "./OrderPanelVals.vue?vue&type=script&lang=js"
import style0 from "./OrderPanelVals.vue?vue&type=style&index=0&id=20468e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20468e5c",
  null
  
)

export default component.exports